import SchoolsPreview from './SchoolsPreview.page';

export default SchoolsPreview;
